// Custom FDS feature to show hide the TOP navigation
// As well as the HEADER navigation that is already part of the GOVUK Header JS
export default class ShowNavigation {
  constructor() {
    this.topNavigation = document.querySelector("#fds-navigation");
    this.topNavigationList = document.querySelector(".fds-navigation__list");
    this.topNavigationShowClass = "fds-navigation--open";
    this.govukHeaderMenuButtonToggler = document.querySelector("#expand-contract-menu-button");
    this.govukHeaderNavigation = document.querySelector("#navigation");

    this.init();
  }

  init() {
    if (this.govukHeaderNavigation || this.topNavigation) {
      this.addAria();
      this.bindUIEvents();
    } else {
      this.hideMenuButton();
    }
  }

  bindUIEvents() {
    const topAndHeaderNavToggler = this.govukHeaderMenuButtonToggler;
    const topNav = this.topNavigation;

    topAndHeaderNavToggler.addEventListener("click", () => {
      if (topNav.classList.contains(this.topNavigationShowClass)) {
        topNav.classList.remove(this.topNavigationShowClass);
        topNav.setAttribute("aria-hidden", "true");
      } else {
        topNav.classList.add(this.topNavigationShowClass);
        topNav.setAttribute("aria-hidden", "false");
      }
    });
  }

  addAria() {
    const headerAndTopLabel = "Show or hide header and top navigation menu";
    const topLabel = "Show or hide top navigation menu";

    if (this.govukHeaderNavigation && this.topNavigation) {
      this.govukHeaderMenuButtonToggler.setAttribute("aria-label", headerAndTopLabel);
      this.govukHeaderMenuButtonToggler
        .setAttribute("aria-controls", `${this.govukHeaderNavigation.id} ${this.topNavigation.id}`);
    } else if (this.topNavigation) {
      this.govukHeaderMenuButtonToggler.setAttribute("aria-label", topLabel);
      this.govukHeaderMenuButtonToggler.setAttribute("aria-controls", this.topNavigation.id);
    }
  }

  hideMenuButton() {
    if (this.govukHeaderMenuButtonToggler) {
      this.govukHeaderMenuButtonToggler.style.display = "none";
    }
  }
}
